import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "step-two-container content-container",
  id: "loadingdiv"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_InterlocuteurList = _resolveComponent("InterlocuteurList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('contact.page.contact.select.label')) + " ", 1),
      _createVNode(_component_ReglePastille, { cle: "contact.interlocuteursParSite" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InterlocuteurList, {
        isLoading: _ctx.isLoading,
        selectedInterlocuteur: _ctx.selectedInterlocuteur,
        interlocuteurs: _ctx.interlocuteurs,
        width: _ctx.width,
        onPick: _ctx.pick,
        onSort: _ctx.sort
      }, null, 8, ["isLoading", "selectedInterlocuteur", "interlocuteurs", "width", "onPick", "onSort"])
    ])
  ]))
}